import { useEffect, useState } from "react";
import { RouterProvider } from "react-router/dom";
import { setUnauthorizedHandler } from "@/api/client";
import { queryClient } from "@/api/queryClient";
import { sessionQueryKey } from "@/api/session";
import { AppProviders } from "./AppProviders";
import { createAppRouter } from "./router";

export function App() {
  const [router] = useState(createAppRouter);

  useEffect(() => {
    // A 401 from any request means the session ended: refetching /auth/me lets RequireSession
    // send the user to /login with a `next` back to where they were.
    setUnauthorizedHandler(() => void queryClient.invalidateQueries({ queryKey: sessionQueryKey }));
    return () => setUnauthorizedHandler(null);
  }, []);

  return (
    <AppProviders queryClient={queryClient}>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
